export const sectionsMultiFilter = {
  multiSelectEddFeaturesTitle: 'Pesquisa por Caract. ({items})'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/sectionsMultiFilter.js